import { FC } from 'react';
import { DsoAddToCartConfirmationModalProps, Styled } from '.';
import { IoCheckmarkCircle } from 'react-icons/io5';
import Image from 'next/legacy/image';
import { useRouter } from 'next/router';
import { Button, Modal } from 'components/core';
import { useI18n } from 'contexts/i18n';
import { DEFAULT_COLORS } from 'components/core/colors';

const DsoAddToCartConfirmationModal: FC<DsoAddToCartConfirmationModalProps> = ({
  name,
  imageUrl,
  price,
  onClose,
}) => {
  const router = useRouter();
  const i18n = useI18n();
  return (
    <Modal>
      <Styled.CartItemContainer>
        <Styled.Header>
          <IoCheckmarkCircle size="28px" style={{ color: DEFAULT_COLORS.green }} />

          <span>{i18n['Item added to your cart!']}</span>
        </Styled.Header>
        <Styled.Body>
          <Styled.Thumbnail>
            <Image
              src={imageUrl}
              alt="Prod Image"
              layout="fill"
              objectFit="cover"
              placeholder="blur"
              blurDataURL="data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjcwMCIgaGVpZ2h0PSI0NzUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImciPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjY2JjYmNiIiBvZmZzZXQ9IjIwJSIgLz4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI2Y5ZjlmOSIgb2Zmc2V0PSI1MCUiIC8+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNjYmNiY2IiIG9mZnNldD0iNzAlIiAvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPHJlY3Qgd2lkdGg9IjcwMCIgaGVpZ2h0PSI0NzUiIGZpbGw9IiNjYmNiY2IiIC8+CiAgPHJlY3QgaWQ9InIiIHdpZHRoPSI3MDAiIGhlaWdodD0iNDc1IiBmaWxsPSJ1cmwoI2cpIiAvPgogIDxhbmltYXRlIHhsaW5rOmhyZWY9IiNyIiBhdHRyaWJ1dGVOYW1lPSJ4IiBmcm9tPSItNzAwIiB0bz0iNzAwIiBkdXI9IjFzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgIC8+Cjwvc3ZnPg=="
            />
          </Styled.Thumbnail>
          <Styled.ProductDetails>
            <div>{name}</div>
            <div>{price}</div>
          </Styled.ProductDetails>
        </Styled.Body>
        <Styled.Footer>
          <Button size="lg" onClick={onClose} variant="secondary" width="35%">
            {i18n['Continue Shopping']}
          </Button>

          <Button
            size="lg"
            onClick={() => router.push('/dso/cartview')}
            variant="primary"
            width="55%"
          >
            {i18n['View Cart']}
          </Button>
        </Styled.Footer>
      </Styled.CartItemContainer>
    </Modal>
  );
};

export default DsoAddToCartConfirmationModal;
